import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  DialogContentText
} from '@mui/material';
import { PersonAdd } from '@mui/icons-material';
import palette from 'src/theme/palette';

const VToolMoveLeadsModal = ({ open, onClose, valuation, onConfirm, loading }) => {
  if (!valuation) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="move-to-leads-dialog-title"
      aria-describedby="move-to-leads-dialog-description"
      PaperProps={{
        sx: {
          borderRadius: 2,
          padding: 1
        }
      }}
    >
      <DialogTitle id="move-to-leads-dialog-title" sx={{ textAlign: 'center', py: 3 }}>
        <PersonAdd
          sx={{
            fontSize: 60,
            color: palette.success.main,
            mb: 2
          }}
        />
        <Typography
          variant="h6"
          sx={{ fontFamily: 'poppinsSemiBold', color: palette.text.primary }}
        >
          Move to Leads
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ textAlign: 'center', pb: 2 }}>
        <DialogContentText
          id="move-to-leads-dialog-description"
          sx={{ color: palette.text.secondary, fontFamily: 'poppinsRegular' }}
        >
          Are you sure you want to move valuation tool entry for <strong>{valuation?.name}</strong>{' '}
          to leads?
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: 'center',
          gap: 2,
          pb: 3,
          px: 3,
          flexDirection: { xs: 'column', sm: 'row' }
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            borderColor: palette.grey[400],
            color: palette.text.primary,
            '&:hover': {
              borderColor: palette.grey[600],
              backgroundColor: palette.action.hover
            },
            minWidth: 100,
            width: { xs: '100%', sm: 'auto' },
            fontFamily: 'poppinsMedium'
          }}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            backgroundColor: palette.success.main,
            color: palette.success.contrastText,
            '&:hover': {
              backgroundColor: palette.success.dark
            },
            minWidth: 100,
            width: { xs: '100%', sm: 'auto' },
            fontFamily: 'poppinsMedium'
          }}
          disabled={loading}
          startIcon={<PersonAdd />}
        >
          {loading ? 'Moving...' : 'Move to Leads'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VToolMoveLeadsModal;
